<template>
  <div class="appVersion-bd tb">
    <div class="search-hd">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="addAppVersionDialog">{{ $t('Common.com_add') }}</el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input :placeholder="$t('base_appVersion.ying_yong_ming_cheng')" v-model="formSearch.search" @fetch="getTableList"></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table index tableCode="app_version" :data="tableList" @column="setColumn" @filter="filterChange" @sort="sortChange" height="100%" :slots="['resSize', 'action']">
        <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" @click="editAppVersionDialog(scope.row)">{{ $t('Common.com_edit') }}</el-button>
          <el-button type="text" size="mini" @click="deleteVersion(scope.row)">{{ $t('Common.com_delete') }}</el-button>
          <el-button type="text" size="mini" v-if="!scope.row.isDefault" @click="defaultVersion(scope.row)">{{ $t('base_appVersion.she_zhi_mo_ren') }}</el-button>
          <el-button type="text" size="mini" @click="onErcodeDialog(scope.row)">{{ $t('base_appVersion.er_wei_ma') }}</el-button>
        </template>
        <template slot="resSize" slot-scope="scope">
          <span>{{ (scope.row.resSize / 1024 / 1024) | formatNumberCalc(2) }}</span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <app-version-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="getTableList"></app-version-dialog>
    <ercode-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></ercode-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import ercodeDialog from './children/ercode_dialog.vue';
import appVersionDialog from './children/app_version_dialog.vue';

export default {
  name: 'appversion',
  components: { ercodeDialog, appVersionDialog },
  computed: {},
  data() {
    return {
      formSearch: {
        search: '',
        pageNum: 1,
        pageSize: 20,
      },
      tableList: [],
      totalRows: 0,

      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
    };
  },
  mounted: function () {
    this.getFuncView();
    this.getTableList();
  },
  methods: {
    getTableList() {
      this.$getJSON(apis.AppVersionPage, this.formSearch).then((res) => {
        const list = res.data.list;
        this.formatAttachList(list, 'appVersionId', 'crm.app.package', 'fullPath').then((result) => {
          this.tableList = result;
          this.totalRows = res.data.total;
        });
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 查看二维码
    onErcodeDialog(row) {
      this.dialogModel = {
        title: this.$t('base_appVersion.ckyybb'),
        row,
      };
      this.dialogVisible = true;
    },
    // 新增版本
    addAppVersionDialog() {
      this.dialogModel1 = {
        type: 'add',
        title: this.$t('base_appVersion.xzyybb'),
      };
      this.dialogVisible1 = true;
    },
    // 编辑版本
    editAppVersionDialog(row) {
      this.dialogModel1 = {
        type: 'edit',
        title: this.$t('base_appVersion.bjyybb'),
        row,
      };
      this.dialogVisible1 = true;
    },
    // 删除版本
    deleteVersion: function (row) {
      this.$showConfirm(this.$t('base_appVersion.nqdscsxbbm'))
        .then(() => {
          this.$postJSON(`${apis.AppVersionDelete}/${row.appVersionId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 设置默认版本
    defaultVersion: function (row) {
      this.$showConfirm(this.$t('base_appVersion.nqdszsxbbwmrbbm'))
        .then(() => {
          this.$postJSON(`${apis.AppVersionDefault}/${row.appVersionId}`, {
            bizClass: row.bizClass,
            bizId: row.bizId,
          }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss"></style>
